import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi, { HttpBackendOptions } from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import axios from 'axios'
import { STORAGE_KEYS } from 'src/constants'
import { ETranslationNs } from 'src/types'
import { getSecretHeader } from 'src/common/utils'

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL!

const loadResources = (loadPath: string) => {
  const [lng, ns] = loadPath.split('|')
  return axios
    .get(`languages/translations/locale/${lng}/${ns}`, {
      headers: {
        ...getSecretHeader(),
      },
      params: {
        userToken: localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),
      },
    })
    .then((response) => response.data)
    .catch()
}

const backendOptions: HttpBackendOptions = {
  loadPath: '{{lng}}|{{ns}}',
  request: (options, lng, payload, callback) => {
    loadResources(lng)
      .then((response) => {
        callback(null, {
          data: response,
          status: 200,
        })
      })
      .catch((error) => {
        callback(error, {
          data: {},
          status: error.status,
        })
      })
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(HttpApi)
  .init<HttpBackendOptions>({
    maxRetries: 0,
    backend: backendOptions,
    fallbackLng: 'en',
    load: 'languageOnly',
    ns: [ETranslationNs.Common],
    defaultNS: ETranslationNs.Common,
    detection: {
      order: ['localStorage'],
    },
    fallbackNS: [ETranslationNs.Common],
  })

export default i18n
